import { Trans, useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
const mediaQuery = [
  { screen: '(max-width: 767px)', width: '90vw' },
  { screen: '(min-width: 768px)', width: '458px' },
]
export default function CompetencyRequirements({ className = '' }): React.ReactElement {
  const { t } = useTranslation('tutorOnDemand')

  return (
    <div className={`w-full ${className}`}>
      <div className="w-full mx-auto">
        <section className="max-w-3xl mx-auto">
          <div className="max-w-3xl">
            <h2 className="my-4 text-lg md:text-h3 font-semibold">
              <span className="bg-clip-text text-transparent bg-gradient-tod-heading">
                {t('landingPage.tutorRequirements.title')}
              </span>
            </h2>
            <p className="max-w-2xl text-black-light-fade sm:text-md leading-8">
              {t('landingPage.tutorRequirements.text')}
            </p>
          </div>

          <div className="flex flex-col gap-5 mt-8 md:flex-row justify-center md:items-center xl:mt-12">
            <ResponsiveImage
              alt={t('landingPage.tutorRequirements.title')}
              className="w-full md:w-114.5 flex-shrink-0"
              height={959}
              imageWidths="458, 500, 600"
              mediaQuery={mediaQuery}
              srcKey="mentor-on-demand/home/competency-requirements/supercrew-signs.png"
              width={916}
            />
            <ul className="ml-4 space-y-3.5 sm:text-md font-light">
              <li>
                <h5>
                  {Trans({
                    t,
                    i18nKey: 'landingPage.tutorRequirements.supercrew.professional-approval',
                    components: { strong: <strong className="font-semibold" /> },
                    children: t('landingPage.tutorRequirements.supercrew.professional-approval'),
                  })}
                </h5>
                <p className="text-xs ml-3 font-light">
                  {t('landingPage.tutorRequirements.supercrew.professional-approval-text')}
                </p>
              </li>
              <li>
                <h5>
                  {Trans({
                    t,
                    i18nKey: 'landingPage.tutorRequirements.supercrew.phone-interview',
                    components: { strong: <strong className="font-semibold" /> },
                    children: t('landingPage.tutorRequirements.supercrew.phone-interview'),
                  })}
                </h5>

                <p className="text-xs ml-4 font-light">
                  {t('landingPage.tutorRequirements.supercrew.phone-interview-text')}
                </p>
              </li>
              <li>
                <h5>
                  {Trans({
                    t,
                    i18nKey: 'landingPage.tutorRequirements.supercrew.trial-lecture-1',
                    components: { strong: <strong className="font-semibold" /> },
                    children: t('landingPage.tutorRequirements.supercrew.trial-lecture-1'),
                  })}
                </h5>
                <p className="text-xs ml-4 font-light">
                  {t('landingPage.tutorRequirements.supercrew.trial-lecture-1-text')}
                </p>
              </li>
              <li>
                <h5>
                  {Trans({
                    t,
                    i18nKey: 'landingPage.tutorRequirements.supercrew.trial-lecture-2',
                    components: { strong: <strong className="font-semibold" /> },
                    children: t('landingPage.tutorRequirements.supercrew.trial-lecture-2'),
                  })}
                </h5>
                <p className="text-xs ml-4 font-light">
                  {t('landingPage.tutorRequirements.supercrew.trial-lecture-2-text')}
                </p>
              </li>
              <li>
                <h5>
                  {Trans({
                    t,
                    i18nKey: 'landingPage.tutorRequirements.supercrew.personal-nterview',
                    components: { strong: <strong className="font-semibold" /> },
                    children: t('landingPage.tutorRequirements.supercrew.personal-nterview'),
                  })}
                </h5>
                <p className="text-xs ml-4 font-light">
                  {t('landingPage.tutorRequirements.supercrew.personal-nterview-text')}
                </p>
              </li>
              <li>
                <h5>
                  {Trans({
                    t,
                    i18nKey: 'landingPage.tutorRequirements.supercrew.no-criminal-record',
                    components: { strong: <strong className="font-semibold" /> },
                    children: t('landingPage.tutorRequirements.supercrew.no-criminal-record'),
                  })}
                </h5>
                <p className="text-xs ml-4 font-light">
                  {t('landingPage.tutorRequirements.supercrew.no-criminal-record-text')}
                </p>
              </li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  )
}
